//angular
import { Component, EventEmitter, OnInit, Output, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
//app
import { AppAnimations } from 'src/app/_shared/animations';
import { DataSharingService } from 'src/app/_core/services';
import { VisibleState, collectionOfBillingPeriod, collectionOfFrequencyUnit, collectionOfFrequencyWeekOption, collectionOfFrequencyMonthOption, collectionOfSubscribeOnOptions, collectionOfSubscribeOn, collectionOfFrequencyYearOption, collectionOfMonth } from 'src/app/app.data';
import { DropDown } from 'src/app/_shared/interfaces/dropdown.interface';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', '[@slideInRightAnimation]': '' },
  selector: 'panel-frequency',
  templateUrl: './panel-frequency.component.html'
})

export class PanelFrequencyComponent implements OnInit, OnDestroy {
  collectionOfBillingInterval: Array<any> = [];
  collectionOfBillingFrequency: Array<DropDown> = collectionOfBillingPeriod;
  collectionOfBillingFrequencyUnit: Array<DropDown> = collectionOfFrequencyUnit;
  collectionOfFrequencyMonthOption: Array<DropDown> = collectionOfFrequencyMonthOption;
  collectionOfFrequencyWeekOption: Array<DropDown> = collectionOfFrequencyWeekOption;
  collectionOfSubscribeOn: Array<DropDown> = collectionOfSubscribeOn;
  collectionOfSubscribeOnOptions: Array<DropDown> = collectionOfSubscribeOnOptions;
  collectionOfFrequencyYearOption: Array<DropDown> = collectionOfFrequencyYearOption;
  collectionOfFrequencyUnit: Array<DropDown> = collectionOfFrequencyUnit;
  collectionOfMonth: Array<DropDown> = collectionOfMonth;
  collectionOfMonthDay: Array<any> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  form: FormGroup;
  formBilling: FormGroup;
  statusBillingFrequency: VisibleState = VisibleState.isHidden;
  statusBillingFrequencyMonth: VisibleState = VisibleState.isHidden;
  statusBillingFrequencyMonthDate: VisibleState = VisibleState.isHidden;
  statusBillingFrequencyMonthDays: VisibleState = VisibleState.isHidden;
  statusBillingFrequencyWeek: VisibleState = VisibleState.isHidden;
  statusBillingFrequencyWeekDays: VisibleState = VisibleState.isHidden;
  statusBillingFrequencyYear: VisibleState = VisibleState.isHidden;
  statusBillingFrequencyYearDate: VisibleState = VisibleState.isHidden;
  statusBillingFrequencyYearMonth: VisibleState = VisibleState.isHidden;
  statusBillingPeriodByDate: VisibleState = VisibleState.isHidden;
  statusColumnSubscribeOnUnit: VisibleState = VisibleState.isHidden;
  statusColumnSubscribeOnDate: VisibleState = VisibleState.isHidden;
  private subs = new Unsubscriber();

  @Output()
  onRemoveBillingInterval: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _fb: FormBuilder,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _shareData: DataSharingService,
  ) {
    this.subs.addSub = this._shareData.currentForm.subscribe(data => {
      if (Object.keys(data).length !== 0) {
        this.form = <FormGroup>data;
        this.formBilling = <FormGroup>this.form.controls.billingInterval;
        if (Object.keys(<FormArray>this.form.controls.productCurrency).length !== 0) {
          const billingInterval = <FormArray>this.form.controls.billingInterval.value;
          if (Number(<Array<any>>billingInterval['intervals'].length) > Number(this.collectionOfBillingInterval.length)) {
            this.collectionOfBillingInterval = <Array<any>>billingInterval['intervals'];
          //   const lastIndex = Number(<Array<any>>productCurrency['currencies'].length) - 1;
          //   // this.statusPriceModelOpt1[lastIndex] = VisibleState.isVisible;
          //   // this.statusPriceModelOpt2[lastIndex] = VisibleState.isHidden;
          //   // this.statusPriceModelOpt3[lastIndex] = VisibleState.isHidden;
          //   // this.statusPriceModelOpt4[lastIndex] = VisibleState.isHidden;
          }
        }
      }
    });
  }

  ngOnInit() {
  }

  onChangeBillingFrequency(_value: string, _index: number) {
    this.setStatusToHidden();
    this.statusBillingFrequency = VisibleState.isHidden;
    this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['frequencyWeekOptionDefault'].setValue('0');
    this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['frequencyMonthOptionDefault'].setValue('0');
    this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['frequencyYearOptionDefault'].setValue('0');
    switch (_value) {
      case 'c':
        this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['billingFrequencyLength'].setValue('1');
        this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['billingFrequencyUnit'].setValue('w');
        this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['frequencyWeekOptionDefault'].setValue('0');
        this.statusBillingFrequency = VisibleState.isVisible;
        this.statusBillingFrequencyWeek = VisibleState.isVisible;
        break;
      case 'd':
      case 'w':
      case 'm':
      case 'y':
        this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['billingFrequencyLength'].setValue('1');
        this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['billingFrequencyUnit'].setValue(_value);
        break;
    }
  }

  onChangeBillingFrequencyUnit(_value: string, _index: number) {
    this.setStatusToHidden();
    this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['frequencyWeekOptionDefault'].setValue('0');
    this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['frequencyMonthOptionDefault'].setValue('0');
    this.form.controls.billingInterval['controls'].intervals['controls'][_index].controls['frequencyYearOptionDefault'].setValue('0');
    switch (_value) {
      case 'w':
        this.statusBillingFrequencyWeek = VisibleState.isVisible;
        this.statusBillingFrequencyWeekDays = VisibleState.isHidden;
        break;
      case 'm':
        this.statusBillingFrequencyMonth = VisibleState.isVisible;
        this.statusBillingFrequencyMonthDate = VisibleState.isHidden;
        this.statusBillingFrequencyMonthDays = VisibleState.isHidden;
        break;
      case 'y':
        this.statusBillingFrequencyYear = VisibleState.isVisible;
        this.statusBillingFrequencyYearDate = VisibleState.isHidden;
        this.statusBillingFrequencyYearMonth = VisibleState.isHidden;
        break;
    }
  }

  onChangeFrequencyMonthOption(_value: string, _index: number) {
    this.statusBillingFrequencyMonthDays = (_value == '1' ? VisibleState.isVisible : VisibleState.isHidden);
    this.statusBillingFrequencyMonthDate = (_value == '2' ? VisibleState.isVisible : VisibleState.isHidden);
  }

  onChangeFrequencyWeekOption(_value: string) {
    this.statusBillingFrequencyWeekDays = (_value == '1' ? VisibleState.isVisible : VisibleState.isHidden);
  }

  onChangeFrequencyYearOption(_value: string) {
    this.statusBillingFrequencyYearMonth = (_value == '1' ? VisibleState.isVisible : VisibleState.isHidden);
    this.statusBillingFrequencyYearDate = (_value == '2' ? VisibleState.isVisible : VisibleState.isHidden);
    this.statusColumnSubscribeOnUnit = VisibleState.isVisible;
    this.statusColumnSubscribeOnDate = VisibleState.isHidden;
  }

  onChangeSubscribeOnUnit(_value: string, _index: number){
    this.statusColumnSubscribeOnUnit = (_value != 'custom' ? VisibleState.isVisible : VisibleState.isHidden);
    this.statusColumnSubscribeOnDate = (_value == 'custom' ? VisibleState.isVisible : VisibleState.isHidden);
  }

  removeBillingPeriod(_index: number) {
    this.collectionOfBillingInterval.splice(_index, 1);
    this.onRemoveBillingInterval.emit(_index);
  }

  setStatusToHidden(){
    this.statusBillingFrequencyMonth = VisibleState.isHidden;
    this.statusBillingFrequencyMonthDate = VisibleState.isHidden;
    this.statusBillingFrequencyMonthDays = VisibleState.isHidden;
    this.statusBillingFrequencyWeek = VisibleState.isHidden;
    this.statusBillingFrequencyWeekDays = VisibleState.isHidden;
    this.statusBillingFrequencyYear = VisibleState.isHidden;
    this.statusBillingFrequencyYearDate = VisibleState.isHidden;
    this.statusBillingFrequencyYearMonth = VisibleState.isHidden;
    this.statusColumnSubscribeOnUnit = VisibleState.isHidden;
    this.statusColumnSubscribeOnDate = VisibleState.isHidden;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
